<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  import resourceHelper from '@/Utils/resourceHelper';
  import { UploadParentItemType } from '@/Types/Enums/UploadParentItemType';
  import useResetableState from '@/VueCore/utils/useResetableState';

  const props = withDefaults(defineProps<{
    limitNumberOfUploads?: number,
    existedUploads?: number,
    newUploads?: number,
    uploadParentItemType?: UploadParentItemType
  }>(), { existedUploads: 0, newUploads: 0, limitNumberOfUploads: 0, uploadParentItemType: UploadParentItemType.businessRequest });
  const visible = defineModel<boolean>({ default: false });
  const { state, resetState } = useResetableState(() => {
    const totalUploads = props.existedUploads + props.newUploads;
    const exceededBy = totalUploads - props.limitNumberOfUploads;

    const additionalRequestNumber = calculateAdditionalParentItems(totalUploads, props.limitNumberOfUploads);
    return {
      maximumAllowedUploads: resourceHelper.getString('MaximumAllowedUploads', { limitNumberOfUploads: props.limitNumberOfUploads }),
      existedUploads: resourceHelper.getString('ExistedUploads', { existedUploads: props.existedUploads }),
      newUploads: resourceHelper.getString('NewUploads', { newUploads: props.newUploads }),
      totalUploadsExceededBy: resourceHelper.getString('TotalUploads', { totalUploads: exceededBy }),
      additionalRequestNumber: additionalRequestNumber,
      uploadLimitNote: resourceHelper.getString(props.uploadParentItemType === UploadParentItemType.partnerRequest ||
        props.uploadParentItemType === UploadParentItemType.businessRequest ?
          'UploadLimitNote' : 'UploadsFolderUploadLimitNote', { additionalRequestNumber })
    }});


  function calculateAdditionalParentItems(totalCount: number, limit: number) {
    if (limit === 0) {
      return 0;
    }
    const result = Math.ceil(totalCount / limit);
    return result - 1;
  }


</script>

<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('UploadLimitTitle')"
    :is-danger="true"
    @open="resetState"
  >
    <template #default>
      <div>
        {{ state.maximumAllowedUploads }}
      </div>
      <div>
        {{ state.existedUploads }}
      </div>
      <div>
        {{ state.newUploads }}
      </div>
      <div>
        {{ state.totalUploadsExceededBy }}
      </div>
      <div v-if="state.additionalRequestNumber > 0">
        <br>
        {{ state.uploadLimitNote }}
      </div>
    </template>
    <template #footer>
      <button
        ref="closeBtn"
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
    </template>
  </ModalDialog>
</template>
